export default __webpack_public_path__ + "static/media/ovi.7c02f884.png";